export interface ApiAcademicYear {
  uuid: string;
  name: string;
  start_date: string;
  end_date: string;
}

export class AcademicYear {
  uuid: string;
  name: string;
  startDate: string;
  endDate: string;

  constructor(data: ApiAcademicYear) {
    this.uuid = data.uuid;
    this.name = data.name;
    this.startDate = data.start_date;
    this.endDate = data.end_date;
  }
}
